import AppConfig from "util/AppConfig";
import ImpossibleTravelEventForm, {
  initialImpossibleTravelConfig
} from "../ImpossibleTravelEvents/ImpossibleTravelEventForm";
import ImpossibleTravelEventSummary from "../ImpossibleTravelEvents/ImpossibleTravelEventSummary";
import RcfEventForm, { initialThresholdedRcfConfig } from "../RcfEvents/RcfEventForm";
import RcfEventSummary from "../RcfEvents/RcfEventSummary";
import LogVolumeEventForm, { initialLogVolumeConfig } from "../LogVolumeEvents/LogVolumeEventForm";
import LogVolumeEventSummary from "../LogVolumeEvents/LogVolumeEventSummary";
export const ANOMALY_SUBTYPES = [
  {
    type: "impossible_travel",
    displayName: "Impossible Travel Anomalies",
    description: "Detect users logging in from geographically distant locations in physically impossible timeframes.",
    formComponent: ImpossibleTravelEventForm,
    summaryComponent: ImpossibleTravelEventSummary,
    defaultConfig: initialImpossibleTravelConfig,
    condition: ({ security: { isValid } }) => isValid,
    hasSidebar: true
  },
  {
    type: "log-volume",
    displayName: "Log Volume Anomalies",
    description: "Alert when message count deviates from a historical baseline.",
    formComponent: LogVolumeEventForm,
    summaryComponent: LogVolumeEventSummary,
    defaultConfig: initialLogVolumeConfig,
    condition: ({ enterprise: { isValid } }) => isValid,
    parentConfigOverrides: {
      search_within_ms: 15 * 60 * 1e3,
      execute_every_ms: 15 * 60 * 1e3
    }
  },
  {
    type: "thresholded_rcf",
    displayName: "Random Cut Forest (RCF) Anomalies",
    description: "Detect anomalies with a Thresholded Random Cut Forest detector.",
    formComponent: RcfEventForm,
    summaryComponent: RcfEventSummary,
    defaultConfig: initialThresholdedRcfConfig,
    condition: ({ security: { isValid } }, eventDefinition) => {
      var _a;
      if (!isValid) return false;
      const isFullRcfEditEnabled = ((_a = AppConfig.pluginUISettings("org.graylog.plugins.securityapp")) == null ? void 0 : _a.enable_full_rcf_definition_edit) === true;
      const isNewDefinition = !eventDefinition.id;
      return isFullRcfEditEnabled || !isNewDefinition;
    }
  }
];
export const getSubtypeByType = (type) => ANOMALY_SUBTYPES.find((s) => s.type === type);
